import 'css-chunksrc/client/scenes/workloads/calendar/years/styles.scss';export default {
  "years": "_years_13o8t_1",
  "year": "_year_13o8t_1"
};